import React from 'react';
import { Route } from 'react-router-dom';
import AppsOverview from '../components/AppsOverview';
import AppDetail from '../components/detail/AppDetail';

const AppsScene = () => (
  <>
    <Route
      component={AppDetail}
      path="/apps/:id/:tab?/:installationId?/:view?/:viewId?/:viewPane?"
    />
    <Route exact component={AppsOverview} menuName="apps_plural" path="/apps" />
  </>
);

export default AppsScene;
